import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M3 21h18v-2H3v2zM3 8v8l4-4-4-4zm8 9h10v-2H11v2zM3 3v2h18V3H3zm8 6h10V7H11v2zm0 4h10v-2H11v2z"
}), 'FormatIndentIncreaseSharp');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/FormatIndentIncreaseSharp.js
// module id = 3847
// module chunks = 2